"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "30", height: "30", viewBox: "0 0 30 30", className: "Icon toolbar-h1-on", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("path", { d: "M1 3.4C1 2.073 2.08 1 3.4 1h23.2C27.927 1 29 2.08 29 3.4v23.2c0 1.326-1.08 2.4-2.4 2.4H3.4C2.073 29 1 27.92 1 26.6V3.4z", stroke: "#000", strokeWidth: "2" }),
            _react2.default.createElement("path", { d: "M14.117 17.57c0 .755-.384.896-1.216.922v.615h4.057v-.615c-.857-.026-1.216-.167-1.216-.922v-5.93c0-.743.359-.884 1.216-.91v-.615h-4.057v.615c.832.026 1.216.167 1.216.91v2.51H9.842v-2.51c0-.743.384-.884 1.216-.91v-.615H7v.615c.858.026 1.216.167 1.216.91v5.93c0 .755-.358.896-1.216.922v.615h4.058v-.615c-.832-.026-1.216-.167-1.216-.922v-2.728h4.275v2.728zM20.76 10c-.666.884-1.216 1.217-2.458 1.396l-.41.064v.525h1.69v5.572c0 .781-.307.832-1.69.922v.628h4.89v-.628c-1.33-.077-1.612-.14-1.612-.922V10h-.41z", fill: "#4C4C4C" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/small/jsx/toolbar-h1-on.js
// module id = 1881
// module chunks = 0